var _style, _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 266 232",
    style: {
      enableBackground: "new 0 0 266 232"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000174596741597737420830000009954628590834402703_);}\n\t.st1{fill:#FB8B44;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 76.74,
    y: 80.34,
    width: 112.52,
    height: 71.31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090979191971477338040000004457831435194378381_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1151",
    style: {
      clipPath: "url(#SVGID_00000090979191971477338040000004457831435194378381_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2038",
    className: "st1",
    d: "M78.97,144.76h-2.15V98.75c-0.39-2.84,0.32-5.72,1.99-8.05c2.97-3.33,7.36-5.04,11.81-4.59 c4.62-0.59,9.24,1.07,12.42,4.46c1.23,1.74,1.72,3.89,1.38,5.99v9.07h-2.15l0.06-9.48c0.24-1.48-0.12-2.99-0.99-4.21 c-2.84-2.77-6.8-4.08-10.73-3.56c-3.77-0.42-7.51,0.96-10.12,3.72c-1.3,1.87-1.86,4.16-1.55,6.41L78.97,144.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2039",
    className: "st1",
    d: "M103.36,126.26c-8.08,0-13.17-1.51-15.15-4.5c-0.72-1.04-1-2.34-0.76-3.58 c0.11-14.63,15.75-14.8,15.91-14.8c0.16,0,15.8,0.17,15.91,14.8c0.24,1.25-0.03,2.54-0.76,3.58 C116.54,124.74,111.44,126.26,103.36,126.26 M103.36,105.67c-0.54,0-13.79,0.18-13.79,12.65l-0.05,0.37 c-0.1,0.64,0.07,1.28,0.46,1.79c0.91,1.3,3.84,3.48,13.38,3.48s12.48-2.18,13.38-3.48c0.4-0.51,0.56-1.17,0.46-1.81l-0.05-0.34 C117.15,105.85,103.93,105.68,103.36,105.67"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_484",
    x: 93.82,
    y: 132.1,
    className: "st1",
    width: 2.12,
    height: 6.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_485",
    x: 102.3,
    y: 133.26,
    className: "st1",
    width: 2.12,
    height: 6.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_486",
    x: 110.79,
    y: 133.26,
    className: "st1",
    width: 2.12,
    height: 6.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_487",
    x: 93.82,
    y: 143.61,
    className: "st1",
    width: 2.12,
    height: 6.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_488",
    x: 102.3,
    y: 144.76,
    className: "st1",
    width: 2.12,
    height: 6.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_489",
    x: 110.79,
    y: 144.76,
    className: "st1",
    width: 2.12,
    height: 6.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2040",
    className: "st1",
    d: "M188.2,119.45h-6.98c-0.32,0-0.62-0.15-0.81-0.4c-0.2-0.26-0.29-0.6-0.24-0.93 c0.39-2.6,0.58-5.23,0.58-7.87c0.2-7.39-1.53-14.71-5.02-21.22c-0.21-0.36-0.23-0.8-0.04-1.18c0.17-0.36,0.53-0.59,0.93-0.61 h11.56c0.61,0.02,1.09,0.53,1.07,1.14c0,0,0,0.01,0,0.01v29.91C189.28,118.91,188.81,119.43,188.2,119.45c-0.01,0-0.01,0-0.02,0  M182.46,117.15h4.67v-27.6h-8.61c3.02,6.48,4.51,13.56,4.38,20.7c0,2.31-0.14,4.61-0.42,6.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2041",
    className: "st1",
    d: "M152.72,119.45h-9.06c-0.61-0.02-1.09-0.53-1.07-1.14c0,0,0-0.01,0-0.01V88.38 c-0.02-0.61,0.45-1.12,1.06-1.15c0,0,0.01,0,0.01,0h13.68c0.4,0.01,0.76,0.25,0.93,0.61c0.18,0.37,0.17,0.82-0.05,1.18 c-3.49,6.52-5.23,13.83-5.02,21.22c0,2.63,0.19,5.26,0.58,7.87c0.05,0.33-0.04,0.66-0.24,0.93c-0.19,0.25-0.49,0.4-0.81,0.4  M144.71,117.13h6.79c-0.28-2.29-0.42-4.59-0.42-6.9c-0.13-7.14,1.37-14.23,4.38-20.7h-10.73L144.71,117.13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2042",
    className: "st1",
    d: "M166.99,134.4c-7.08,0-13.36-6.52-15.29-15.85c-0.07-0.34,0-0.69,0.21-0.97 c0.19-0.27,0.5-0.43,0.83-0.43h28.51c0.33,0,0.64,0.16,0.83,0.43c0.2,0.28,0.28,0.63,0.21,0.97 C180.35,127.88,174.07,134.4,166.99,134.4 M154.11,119.45c0,7.11,5.77,12.88,12.88,12.88c7.11,0,12.88-5.77,12.88-12.88H154.11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2043",
    className: "st1",
    d: "M181.24,119.45h-28.51c-0.55,0-1.02-0.42-1.07-0.97c-0.4-2.73-0.61-5.48-0.61-8.24 c-0.2-7.83,1.65-15.59,5.37-22.49c2.09-5.82,8.5-8.84,14.32-6.76c3.15,1.13,5.63,3.61,6.76,6.76c3.72,6.9,5.57,14.65,5.37,22.49 c0,2.76-0.2,5.51-0.61,8.24c-0.06,0.55-0.52,0.97-1.07,0.97 M153.59,117.15h26.68c0.3-2.29,0.45-4.59,0.45-6.9 c0.2-7.39-1.53-14.71-5.02-21.22c-1.56-4.84-6.75-7.5-11.59-5.93c-2.82,0.91-5.02,3.12-5.93,5.93 c-3.49,6.52-5.22,13.83-5.02,21.22C153.15,112.56,153.29,114.86,153.59,117.15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2044",
    className: "st1",
    d: "M180,149.37L180,149.37l-25.76-0.31c-0.35-0.01-0.67-0.19-0.85-0.48 c-0.2-0.31-0.25-0.68-0.14-1.03c0.18-0.6,4.59-14.59,13.73-14.59c9.14,0,13.82,14.27,14.01,14.88c0.12,0.36,0.07,0.76-0.14,1.07 c-0.19,0.29-0.51,0.47-0.86,0.48 M155.8,146.79l22.61,0.27c-1.42-3.51-5.39-11.81-11.43-11.81c-6.04,0-9.85,8.1-11.18,11.52"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBao);
export default __webpack_public_path__ + "static/media/baño.82ad0f18480570c93fc0622514a1e71a.svg";
export { ForwardRef as ReactComponent };